import { createVNode as i, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ListFilledStandard.js";
import l from "../components/PfIcon.js";
const t = (r, e) => {
  const a = {
    ...r,
    ...e.attrs
  };
  return i(l, o(a, {
    icon: d
  }), null);
};
t.displayName = "ListFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
